import { useFeatureGates } from '@office-start/feature-gates-service';
import { withLazyFeatureGateErrorBoundary } from '@office-start/office-home-app-shared';
import { IDLE_LOW_PRIORITY, IDLE_VERYLOW_PRIORITY, } from '@office-start/scheduler-service';
import { useComputedStyle } from '@office-start/window-utility';
import React, { lazy, useMemo } from 'react';
import { useGetContentNode } from '../../hooks';
import styles from './BackgroundImage.module.scss';
export var BackgroundImage = function () {
    var _a, _b;
    var contentNode = useGetContentNode();
    var contentMarginLeftOffset = useComputedStyle(contentNode, 'margin-left');
    var isIdleVeryLowPriorityLoad = ((_b = (_a = useFeatureGates().data) === null || _a === void 0 ? void 0 : _a.result.idleVeryLowPriorityLoadGates) === null || _b === void 0 ? void 0 : _b.idleVeryLowPriorityLoadEnabled) || false;
    var VisualBackgroundLazy = useMemo(function () {
        return withLazyFeatureGateErrorBoundary(lazy(function () {
            return import(
            /* webpackChunkName: "visual-background" */ '@office-start/visual-background-component');
        }), 'VisualBackground', {
            disabledFeatureGateSelector: function (featureGates) { var _a; return !((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.visualGates) === null || _a === void 0 ? void 0 : _a.visualEnabled); },
            schedulePriority: isIdleVeryLowPriorityLoad
                ? IDLE_VERYLOW_PRIORITY
                : IDLE_LOW_PRIORITY,
        });
    }, []);
    return (React.createElement("div", { className: styles.container },
        React.createElement(VisualBackgroundLazy, { widthRestrictorOffset: contentMarginLeftOffset })));
};
//# sourceMappingURL=BackgroundImage.js.map